import * as Sentry from "@sentry/react";
import { useAtomValue } from "jotai";
import { useEffect } from "react";

import { userAtom, workosAuthAtom } from "~/atoms";

/**
 * Tags Sentry events with the signed-in user on whichever auth path is live.
 * A component rather than a store subscription in utils/Sentry: `userAtom`
 * reads localStorage once, on first read, and a read at import time runs
 * before the session is written, pinning it to signed-out.
 */
const SentryUserIdentity = () => {
  const workosUserId = useAtomValue(workosAuthAtom).user?.id;
  const zitadelUserId = useAtomValue(userAtom)?.profile.sub;
  const userId = workosUserId ?? zitadelUserId ?? null;

  useEffect(() => {
    Sentry.setUser(userId ? { id: userId } : null);
  }, [userId]);

  return null;
};

export default SentryUserIdentity;
